import { useState } from "react";

import { Box, FormControlLabel, FormGroup, useTheme } from "@mui/material";
import Button from "@mui/material/Button";
import { v4 as uuid } from "uuid";

import controlDisplayTypeList from "../../assets/controlDisplayTypeList";
import Checkbox from "../ui/omniCheckbox";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogTitle from "../ui/omniDialogTitle";
import OmniMenuItem from "../ui/omniMenuItem";
import OmniTextField from "../ui/omniTextField";
import AlertDialog from "./alertDialog";

const PracticeAssessmentTemplateQuestionAnswerOptionDialog = props => {
  const {
    open,
    dialogTitle = "Add Question",
    okMessage = "OK",
    cancelMessage = "Cancel",
    deleteMessage = "remove",
    maxWidth = "sm",
    fullWidth = true,
    initialValues,
  } = props;

  const [editedValues] = useState(initialValues);
  const [value, setValue] = useState(initialValues.value);
  const [displayType, setDisplayType] = useState(initialValues.displayType);
  const [text, setText] = useState(initialValues.text);
  const [subText, setSubText] = useState(initialValues.subText);
  const [helpText, setHelpText] = useState(initialValues.helpText);
  const [isLast, setIsLast] = useState(initialValues.isLast);

  const [showConfirm, setShowConfirm] = useState(false);

  const nextQuestionID = initialValues.nextQuestionID;

  const onDeleteHandler = () => {
    props.onDelete(initialValues);
  };

  const onAcceptHandler = () => {
    // notice we didn't touch the id
    // probably because we don't have one.....
    editedValues.value = value;
    editedValues.displayType = displayType;
    editedValues.text = text;
    editedValues.subText = subText;
    editedValues.helpText = helpText;
    editedValues.nextQuestionID = nextQuestionID;
    editedValues.isLast = isLast;

    props.onAccept(editedValues);
  };

  const onCloseHandler = () => {
    props.onClose();
  };

  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onCloseHandler}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            webkitUserSelect: "none",
            userSelect: "none",
            height: "100%",
            minHeight: 200,
          }}
        >
          <OmniTextField
            label="Option Value"
            type="textInput"
            name={uuid()} //prevents AutoComplete Suggestions
            variant="outlined"
            value={value}
            onChange={event => {
              setValue(event.target.value);
            }}
            placeholder={"Value of Answer Option (Must be unique)"}
          />
          <OmniTextField
            required
            label="Display Type"
            select
            name={uuid()} //prevents AutoComplete Suggestions
            variant="outlined"
            value={displayType}
            onChange={event => {
              setDisplayType(event.target.value);
            }}
            placeholder={"Select the control display type"}
          >
            {controlDisplayTypeList.map(controlDisplayTypeList => (
              <OmniMenuItem
                key={controlDisplayTypeList.displayType}
                value={controlDisplayTypeList.displayType}
              >
                {controlDisplayTypeList.displayType}
              </OmniMenuItem>
            ))}
          </OmniTextField>

          <OmniTextField
            required
            label="Answer Text"
            type="textInput"
            name={uuid()} //prevents AutoComplete Suggestions
            variant="outlined"
            value={text}
            onChange={event => {
              setText(event.target.value);
            }}
            placeholder={"Enter the question text"}
          />

          <OmniTextField
            label="Answer Subtext"
            type="textInput"
            name={uuid()} //prevents AutoComplete Suggestions
            variant="outlined"
            value={subText}
            onChange={event => {
              setSubText(event.target.value);
            }}
            placeholder={"Enter the question subtext"}
          />

          <OmniTextField
            label="Help Text"
            type="textInput"
            name={uuid()} //prevents AutoComplete Suggestions
            variant="outlined"
            multiline
            rows={4}
            value={helpText}
            onChange={event => {
              setHelpText(event.target.value);
            }}
            placeholder={"Enter the instructions for completing the question"}
          />
          <FormGroup aria-label="position" row>
            <FormControlLabel
              value="Complete Assessment after Answer"
              control={
                <Checkbox
                  checked={isLast}
                  onChange={event => {
                    setIsLast(isLast => !isLast);
                  }}
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              }
              label="Complete Assessment after Answer"
              labelPlacement="right"
            />
          </FormGroup>
        </Box>
      </DialogContent>
      <DialogActions>
        {initialValues.id != null && (
          <Button
            onClick={() => setShowConfirm(true)}
            sx={{ position: "absolute", left: theme.spacing(2) }}
            color="secondary"
            variant="contained"
          >
            {deleteMessage}
          </Button>
        )}
        {cancelMessage && (
          <Button onClick={onCloseHandler} color="secondary" variant="contained">
            {cancelMessage}
          </Button>
        )}
        <Button onClick={onAcceptHandler} color="secondary" variant="contained">
          {okMessage}
        </Button>
      </DialogActions>

      {showConfirm && (
        <AlertDialog
          open={showConfirm}
          dialogTitle={`Confirm`}
          dialogMessage={"Are you sure you want to remove this assessment?"}
          onAccept={() => {
            onDeleteHandler();
            setShowConfirm(false);
          }}
          onClose={() => {
            setShowConfirm(false);
          }}
        />
      )}
    </Dialog>
  );
};

export default PracticeAssessmentTemplateQuestionAnswerOptionDialog;
